import { useEffect, useState } from "react";
import classes from "../../StudioErstellen/StudioEquipment/StudioEquipment.module.css";
import EquipmentPopUp from "../../StudioErstellen/StudioEquipment/EquipmentPopUp";
import { NotificationModal } from "../../StudioErstellen/StudioEquipment/NotificationModal";

const makeLocalItemId = () => {
    if (typeof crypto !== "undefined" && crypto.randomUUID) {
        return crypto.randomUUID();
    }
    return `${Date.now()}_${Math.random().toString(36).slice(2, 9)}`;
};

const makeEmptyItem = () => ({ name: "", count: 1, id: makeLocalItemId() });

const StudioEquipmentEditorPhoneBox = ({ name, items, setItemsForCategory }) => {
    const [popUpActive, setPopUpActive] = useState(false);
    const [equipmentItems, setEquipmentItems] = useState([makeEmptyItem()]);
    const [isActive, setIsActive] = useState(items.length > 0);
    const [editingItem, setEditingItem] = useState(null);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        setIsActive(items.length > 0);
    }, [items.length]);

    const handleValidation = (_, currentId, newName) => {
        let isValid = true;
        const errors = { name: "" };
        const normalized = newName.trim().toLowerCase();
        const hasDuplicate = items.some((item) => item.id !== currentId && item.name.trim().toLowerCase() === normalized);

        if (hasDuplicate) {
            errors.name = "Name schon vorhanden.";
            isValid = false;
        }

        return { isValid, errors };
    };

    const openPopUp = () => {
        setEditingItem(null);
        setEquipmentItems([makeEmptyItem()]);
        setPopUpActive(true);
        setIsActive(true);
    };

    const closePopUp = () => {
        if (items.length === 0) {
            setIsActive(false);
        }
        setPopUpActive(false);
        setEditingItem(null);
        setEquipmentItems([makeEmptyItem()]);
    };

    const editEquipment = (item) => {
        setEditingItem(item);
        setEquipmentItems([{ ...item }]);
        setPopUpActive(true);
    };

    const handleSave = (newEntries, editedItem) => {
        const validEntries = (newEntries || []).filter((entry) => entry?.name?.trim());
        if (validEntries.length === 0) return;

        if (editedItem) {
            const editedEntry = validEntries[0];
            setItemsForCategory(items.map((item) => (item.id === editedItem.id ? editedEntry : item)));
            return;
        }

        setItemsForCategory([...items, ...validEntries]);
    };

    const handleSaveAndAdd = (newEntries) => {
        const valid = (newEntries || []).filter((entry) => entry?.name?.trim());
        if (valid.length === 0) return;
        setItemsForCategory([...items, ...valid]);
        setEquipmentItems([makeEmptyItem()]);
    };

    const deleteEquipment = (itemToDelete) => {
        if (!itemToDelete) {
            closePopUp();
            return;
        }
        setItemsForCategory(items.filter((item) => item.id !== itemToDelete.id));
        closePopUp();
    };

    const handleToggleActive = (checked) => {
        if (!checked && items.length > 0) {
            setShowModal(true);
            return;
        }
        setIsActive(checked);
        if (checked) {
            openPopUp();
        }
    };

    const truncateText = (text, limit = 25) => (text.length > limit ? `${text.substring(0, limit - 3)}...` : text);

    const handleModalConfirm = () => {
        setShowModal(false);
        setIsActive(false);
        setItemsForCategory([]);
    };

    const handleModalCancel = () => {
        setShowModal(false);
        setIsActive(true);
    };

    return (
        <>
            <div className={classes.equipmentBoxPhone} style={{ marginBottom: items.length > 0 ? 20 : 0 }}>
                <span className="semiboldMedium">{name}</span>
                <div className={classes.switchContainer}>
                    <label className={classes.switch}>
                        <input type="checkbox" checked={isActive} onChange={(e) => handleToggleActive(e.target.checked)} />
                        <span className={classes.slider}></span>
                    </label>
                </div>
            </div>
            {items.map((item, index) => (
                <div key={item.id || index} className={classes.equipmentItem}>
                    <div className={classes.equipmentItemContainer}>
                        <span className="semiboldXs">{truncateText(item.name)}</span>
                        <span className={`${classes.equipmentItemCount} semiboldXs`}>{item.count}</span>
                    </div>
                    <button className={`${classes.equipmentEditButton} semiboldXs`} onClick={() => editEquipment(item)}>
                        Bearbeiten
                    </button>
                </div>
            ))}
            {items.length > 0 && (
                <div className={classes.equipmentAddButtonContainer}>
                    <button onClick={openPopUp} className={`${classes.equipmentAddButton} semiboldXs`}>
                        Weiteres Licht hinzufügen
                    </button>
                </div>
            )}
            <div className={classes.heavyLine}></div>
            {popUpActive && (
                <EquipmentPopUp
                    fromEditor={true}
                    closePopUp={closePopUp}
                    name={name}
                    equipmentItems={equipmentItems}
                    setEquipmentItems={setEquipmentItems}
                    editingItem={editingItem}
                    deleteEquipment={deleteEquipment}
                    onSave={handleSave}
                    onSaveAndAdd={handleSaveAndAdd}
                    handleValidation={handleValidation}
                />
            )}
            <NotificationModal
                open={showModal}
                onBackdropClick={handleModalCancel}
                onConfirm={handleModalConfirm}
                onCancel={handleModalCancel}
                onDelete={handleModalConfirm}
            >
                {name}
            </NotificationModal>
        </>
    );
};

export default StudioEquipmentEditorPhoneBox;
